export function isManagerOnly(roles) {
    const operational = ['ROLE_ADMIN','ROLE_SUPER_ADMIN','ROLE_SPECIALIST','ROLE_SPECIALIST_TS','ROLE_SUPPORT','ROLE_SUPPORT_AGENT','ROLE_SUPPORT_LEAD','ROLE_HEAD_TS','ROLE_MANAGER_TS','ROLE_CTO','ROLE_YK','ROLE_OKK','ROLE_EXTERNAL_CASHBOX'];
    return roles.includes('ROLE_MANAGER') && !roles.some(role=>operational.includes(role));
}
